var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line, _line2, _rect, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 621.96 146.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}.cls-2{fill:none;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:#303030;}.cls-4{fill:#f2f2f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.28,48.53c0,17-12.64,30.1-29.24,30.1H213V18.44H237C253.64,18.44,266.28,31.51,266.28,48.53Zm-13.24,0c0-10.32-6.54-16.85-16-16.85H226.72V65.39H237C246.5,65.39,253,58.85,253,48.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.44,68.31a11.23,11.23,0,0,0,8.25-3.26L314,71c-4.21,5.85-10.58,8.86-18.74,8.86-14.71,0-23.83-9.89-23.83-22.71s9.29-22.7,22.88-22.7c12.55,0,21.84,9.72,21.84,22.7a25.23,25.23,0,0,1-.51,5.16H285.12C286.75,66.77,290.71,68.31,295.44,68.31Zm7.91-15.65c-1.38-5-5.25-6.79-9.12-6.79-4.9,0-8.17,2.41-9.37,6.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.89,68.31a11.23,11.23,0,0,0,8.25-3.26L363.46,71c-4.21,5.85-10.58,8.86-18.75,8.86-14.7,0-23.82-9.89-23.82-22.71s9.29-22.7,22.88-22.7c12.55,0,21.84,9.72,21.84,22.7a25.23,25.23,0,0,1-.51,5.16H334.57C336.2,66.77,340.16,68.31,344.89,68.31Zm7.91-15.65c-1.38-5-5.25-6.79-9.12-6.79-4.9,0-8.17,2.41-9.37,6.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.19,57.13c0,12.82-9.29,22.71-20.55,22.71-5.77,0-10-2-12.82-5.25V95.83h-12.9V35.63h12.9v4c2.84-3.27,7.05-5.25,12.82-5.25C409.9,34.43,419.19,44.32,419.19,57.13Zm-12.9,0c0-6.45-4.3-10.49-10.23-10.49s-10.24,4-10.24,10.49,4.3,10.5,10.24,10.5S406.29,63.58,406.29,57.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.69,31.68V43.29h22.36V56.53H440.69v22.1H426.93V18.44h36.55V31.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.22,15.85h12.9V78.63h-12.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.43,57.13a22.79,22.79,0,1,1,22.79,22.71A22.53,22.53,0,0,1,491.43,57.13Zm32.68,0c0-6.1-4.3-10.14-9.89-10.14s-9.89,4-9.89,10.14,4.3,10.15,9.89,10.15S524.11,63.24,524.11,57.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.66,35.63l-13.76,43h-12l-6.88-23-6.88,23h-12l-13.76-43h13.76l6.19,23,6.71-23h12l6.7,23,6.2-23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.79,107.16h-7.92v24h-7v-24h-7.92v-6.78h22.88Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.19,124.41v6.78H247.83V100.38H267v6.78h-12.1v5.1h11V119h-11v5.46Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.57,115.78a15.62,15.62,0,0,1,16-16,15.37,15.37,0,0,1,13.2,7.13l-6.07,3.52a8,8,0,0,0-7.13-3.78c-5.46,0-9,3.65-9,9.15s3.52,9.16,9,9.16a7.92,7.92,0,0,0,7.13-3.79l6.07,3.52a15.25,15.25,0,0,1-13.2,7.13A15.61,15.61,0,0,1,273.57,115.78Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.81,100.38v30.81h-7V119h-9.68v12.24h-7V100.38h7v11.79h9.68V100.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.25,100.38v30.81H362l-11.88-16.73v16.73h-7V100.38h5.28l11.88,16.72V100.38Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.17,115.78a16,16,0,1,1,16,16A15.88,15.88,0,0,1,375.17,115.78Zm25,0a9,9,0,1,0-9,9.16A8.76,8.76,0,0,0,400.16,115.78Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.16,124.41v6.78h-18V100.38h7v24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.12,115.78a16,16,0,1,1,16,16A15.88,15.88,0,0,1,437.12,115.78Zm25,0a9,9,0,1,0-9,9.16A8.76,8.76,0,0,0,462.11,115.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.57,116.66c0,9.42-6.56,15.14-15.19,15.14-9.68,0-16.63-7.13-16.63-16A16,16,0,0,1,491.9,99.76a15.76,15.76,0,0,1,13.47,7l-6,3.43a9.25,9.25,0,0,0-16.59,5.63c0,5.24,3.7,9.07,9.68,9.07,4.09,0,6.78-1.81,7.88-4.76h-8.23V114h15.45Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.52,100.38v30.81h-7V100.38Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.12,124.41v6.78H531.76V100.38H550.9v6.78H538.8v5.1h11V119h-11v5.46Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.5,124.19l6.07-3.52a6.46,6.46,0,0,0,6.47,4.27c3.35,0,4.18-1.32,4.18-2.51,0-1.89-1.76-2.64-6.38-3.92s-9.06-3.48-9.06-9.37,5-9.38,10.34-9.38a12,12,0,0,1,11.26,7l-5.94,3.47c-1.05-2.2-2.51-3.56-5.32-3.56-2.2,0-3.3,1.1-3.3,2.33,0,1.41.75,2.38,5.54,3.83s9.9,3,9.9,9.55c0,5.94-4.75,9.46-11.44,9.46C563.35,131.8,559.22,128.72,557.5,124.19Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 218.21,
    y1: 86.08,
    x2: 367.49,
    y2: 86.08
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 391.62,
    y1: 86.08,
    x2: 583.28,
    y2: 86.08
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.06,
    y: 18.03,
    width: 152.89,
    height: 115.52,
    rx: 15.61
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.79,63.31c-1.54,0-2.83-.08-4.1,0a42.17,42.17,0,0,0-6.27.65,22,22,0,0,0-17.21,20c-.49,7.33-.61,14.7-.64,22a17.06,17.06,0,0,0,8.48,15.2,2.77,2.77,0,0,0,2.32.66c5.76,0,11.53,0,17.29,0a16.7,16.7,0,0,0,5.6-.92,16.4,16.4,0,0,0,10.95-15.32c.05-7.66,0-24.08,0-24.77H121c1.82-5.46,3.59-10.8,5.46-16.4-.86,0-21.19,0-30.76,0a4.32,4.32,0,0,0-3.62,1.54c-1.09,1.25-2.34,2.38-3.61,3.64-.35-1.77-.31-23,0-24.22h35.2c1.82-5.44,3.69-10.86,5.42-16.38a9.61,9.61,0,0,0-1.14,0c-9.31,0-18.62,0-27.93,0a3.16,3.16,0,0,0-2,.73q-12.63,9.51-25.3,19a2.24,2.24,0,0,0-1,2C71.81,54.25,71.79,63.31,71.79,63.31Zm-5.33,47.34c-1.64-.07-3.29,0-4.93-.13-2.8-.16-4.15-2.17-4.22-4.73.08-2.21.14-15.52.23-19.84a9.19,9.19,0,0,1,6-8.57A4.68,4.68,0,0,1,65,77c2.25,0,4.5,0,7,0,0,1.4-.07,19.07-.06,26.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.42de69a8402197def5d6795ff1424e9a.svg";
export { ForwardRef as ReactComponent };